import { AssetStoryblok } from '@monoimin/sb-types';

export const getAssetImageSrc = (item: AssetStoryblok) => {
  return item.filename;
};

export default getAssetImageSrc;
